import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/switchMap';

// Services 
import { VisorService } from '../../services/visor.service';
import { UtilsService } from '../../services/utils.service';
import { SearchService } from '../../services/search.service';

declare var jQuery: any;

@Component({
  selector: 'sidebar-component',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  providers: [VisorService, UtilsService]
})
export class SidebarComponent implements OnInit {

  // Define Properties
  valueSearch: string;
  subjectSearch: Subject<string> = new Subject<string>();
  searching: boolean = false;
  searchResults: Array<any> = [];
  ajcode: string;
  tiposDocumento: any;
  findInDocuments: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _visor: VisorService,
    private _utils: UtilsService,
    private _search: SearchService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.ajcode = params['id'];
    });

    this.searchValue()
      .debounceTime(600)
      .subscribe(t => {
        this.onSearchValue(t);
      });

    this._search.getTiposDocumento().subscribe(res => {
      this.tiposDocumento = res;
    });
  }

  public searchValue(): Observable<string> {
    return this.subjectSearch.asObservable();
  }

  // Methods
  onSearchValue(value: string) {
    this.searching = true;

    if (this.findInDocuments) {
      this._search.getFacetedSearchDocument(value)
        .subscribe(res => {
          this.searching = false;
          //this.searchResults = res.Page;
          let preResult: Array<{ m_Item1: string, m_Item2: string, m_Item3: number }> = res.FacetedResult;
          let result: Array<{ text: string, value: string, qty: number }> = [];

          preResult.filter(t => t.m_Item1 == "idtype").forEach(t => {
            let tipo = this.tiposDocumento[t.m_Item2];
            if (tipo) {
              let desc = tipo.text;
              result.push({ text: desc, value: t.m_Item2, qty: t.m_Item3 });
            } else {
              result.push({ text: t.m_Item2, value: t.m_Item2, qty: t.m_Item3 });
              result.sort((a, b) => { return a.text == b.text ? 0 : +(a.text > b.text) || -1; });
            }
          });

          this.searchResults = result;
        });
    } else {
      this._visor.searchText(value, this.ajcode)
        .subscribe(res => {
          this.searching = false;
          let result: Array<{ Article: string, GuidBlock: string, InnerText: string }> = [];
          res.Page.forEach(t => {
            result.push({ Article: t.Article, GuidBlock: t.GuidBlock, InnerText: t.InnerText });
          });
          this.searchResults = result;
        });
    }
  }

  onClickSearchButton() {
    let value = this.valueSearch;
    if (!this._utils.isNullOrEmpty(value)) {
      this.subjectSearch.next(value);
    }
  }

  onChangeSearchValue() {

  }

  showAds(event) {
    if(typeof jQuery === "function")
      jQuery("#findArticlesAddNoteDialog").modal("show");
  }

  onChangeCheckboxFindInDocuments(event) {
    this.searchResults = [];
  }

  onClickFaceta() {
    if(typeof jQuery === "function")
      jQuery("#findArticlesAddNoteDialog").modal("show");
  }
}



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/articulo/sidebar/sidebar.component.ts